import { THREE } from 'uweb/three'
import { maptalks } from 'uweb/maptalks'
import { Point, UTM, colorize } from 'uweb/utils'
import { KeyValue, Safe, Loop, Delay, log } from 'utils/web'

import { stringToColour, pointMaterial } from '../hooks/utils'

export class ViewAsPoints {

    cfg: iArgs
    obj: any = {}

    constructor(cfg: iArgs) {
        this.cfg = cfg
    }

    altitude = (el: number) => {
        const elevation = el || 1500
        return this.cfg.MapView?.threeLayer.distanceToVector3(elevation, elevation).x
    }

    toGPS = (ref: string, rows: any[]) => {

        if (ref === 'UTM') {

            let zone = KeyValue('Zone')
            const prsd: any = []

            if (typeof zone === 'string') {
                const [znum, zlet] = zone.split(',')
                if (znum && zlet) {
                    for (const [x, y, z] of rows) {
                        const { lat, lng } = UTM.convertUtmToLatLng(x, y, znum, zlet)
                        prsd.push([lat, lng, z])
                    }
                }
            }

            return prsd

        } else return rows

    }

    add = (key: string, ref: string, rows: any[]) => {
        try {
            let gps = this.toGPS(ref, rows)
            let is_3D_enabled = KeyValue('3D') === 'yes'
            let is_3D_diff = Number(KeyValue('Elevation'))
            const material = pointMaterial(stringToColour(`${key}-end`), stringToColour(`${key}-end`), 2)
            const geometry = new THREE.BufferGeometry()
            const positions: number[] = []
            let anchor: THREE.Vector3 | null = null

            for (const n of gps) {
                const xy = this.cfg.MapView?.threeLayer.coordinateToVector3(new maptalks.Coordinate(n[1], n[0]), 0)
                const z = is_3D_enabled ? this.cfg.MapView?.threeLayer.distanceToVector3(n[2] - is_3D_diff, n[2] - is_3D_diff).x : 0

                if (!anchor) anchor = new THREE.Vector3(xy.x, xy.y, z)

                positions.push(xy.x - anchor.x, xy.y - anchor.y, z - anchor.z)
            }

            geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3))
            const points = new THREE.Points(geometry, material)
            if (anchor) points.position.copy(anchor)
            return points
        } catch (err: any) { log.error(`[LineString.add()]: ${err.message}`) }
    }

    removeStartsWith = (key: string) => {

        if (this.obj) for (const x in this.obj) if (x.indexOf(key) === 0) {

            this.cfg.MapView?.threeLayer.removeMesh(this.obj[x])
            delete this.obj[x]

        }

    }

    remove = (key: string) => {

        if (this.obj.hasOwnProperty(key)) {

            this.cfg.MapView?.threeLayer.removeMesh(this.obj[key])
            delete this.obj[key]

        }

    }

    remove_all = () => {
        for (const x in this.obj) this.remove(x)
    }

    insert = (key: string, ref = 'UTM', rows: any[]) => {

        if (this.obj.hasOwnProperty(key)) this.remove(key)

        this.obj[key] = this.add(key, ref, rows)
        this.cfg.MapView?.threeLayer.addMesh(this.obj[key])

    }

    addWithFilter = (key: string, ref = 'UTM', res: any[]) => {

        for (const x of res) {

            const { qr, rows } = x

            const mapping: any = {}

            if (Array.isArray(rows)) for (const x of rows) {

                const { prefix, geom: { coordinates: c }, data } = x

                if (qr.pane?.RTK === true) {

                    const [, g1, g2] = data.split('|')
                    if (g1.indexOf('rtk') === 0 && g2.indexOf('rtk') === 0) { }
                    else continue

                }

                if (qr.pane?.Vehicles !== '*') {

                    const vehicles = qr.pane?.Vehicles.split(',')
                    const [_proj, _type, _name] = x.prefix.split('.')
                    if (vehicles.includes(_name)) { }
                    else continue

                }

                if (!mapping.hasOwnProperty(prefix)) mapping[prefix] = { prefix, color: [stringToColour(prefix), stringToColour(`${prefix}-end`)], points: [] }
                mapping[prefix].points.push([c[0], c[1], c[2], data])

            }

            Object.keys(mapping).forEach((v, i) => {

                Delay(() => { this.insert(`${key}_${v}`, 'UTM', mapping[v].points) }, 250 * i)

            })

        }

    }

}